"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function Scroll() {
  const pathname = usePathname();

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        const headerOffset = 80; // Adjust based on header height
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - headerOffset, behavior: "smooth" });
      }
    }
  }, [pathname]);

  return null;
}
